import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  FEES_SUMMARY_REQUEST: (selectedYears, DateKey) => ({
    selectedYears,
    DateKey,
  }),
  FEES_DETAIL_REQUEST: (selectedYears, DateKey) => ({
    selectedYears,
    DateKey,
  }),
  FEES_SUCCESS: (payload) => payload,
  FEES_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    FEES_SUMMARY_REQUEST: summaryReducer,
    FEES_DETAIL_REQUEST: detailReducer,
    FEES_SUCCESS: successReducer,
    FEES_FAILURE: failureReducer,
  },
  initState,
);
